export default {
  search: {
    placeholder: 'Ürün ara...',
    button: 'Ara',
    photo: 'Fotoğrafla ara',
  },
  suggest: {
    history: 'Geçmiş',
    category: 'Kategori',
    brand: 'Marka',
    article: 'Ürün kodu',
    product: 'Ürün',
  },
  filters: {
    title: 'Filtreler',
    category: 'Kategori',
    gender: 'Cinsiyet',
    color: 'Renk',
    size: 'Beden',
    price: 'Fiyat',
    priceFrom: 'min',
    priceTo: 'maks',
    reset: 'Filtreleri sıfırla',
    apply: 'Uygula',
    clear: 'Temizle',
  },
  results: {
    found: '{count} ürün bulundu',
    notFound: 'Sonuç bulunamadı',
    notFoundHint: 'Sorgunuzu değiştirmeyi veya filtreleri sıfırlamayı deneyin',
  },
  crop: {
    search: 'Benzerlerini bul',
    cancel: 'İptal',
    hint: 'Görüntüde bir alan seçin',
  },
  error: {
    title: 'Bir hata oluştu',
    text: 'Sonuçlar yüklenemedi. Lütfen daha sonra tekrar deneyin.',
    retry: 'Tekrar dene',
  },
  panel: {
    close: 'Kapat',
  },
};
